import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { noResultsFound: String }

  connect() {
    if (window.$ && window.$.fn.select2) {
      const noResultFoundText = this.noResultsFoundValue
      setTimeout(() => {
        try {
          this.select2 = window.$(this.element).select2({
            dropdownParent: window.$(document.body),
            placeholder: this.element.dataset.placeholder || this.element.querySelector('option[value=""]')?.textContent || 'Select...',
            allowClear: false,
            language: {
              noResults: function() {
                return noResultFoundText;
              }
            }
          })
        } catch (e) {
          console.error("Select2 initialization failed:", e);
        }
      }, 50)
    } else {
      console.error("Select2 or jQuery not available in window scope.");
    }
  }

  disconnect() {
    if (this.select2 && window.$ && window.$.fn.select2) {
      try {
        window.$(this.element).select2('destroy')
      } catch (e) {
        console.error("Select2 destroy failed:", e);
      }
    }
  }
}
